import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./app";
import reportWebVitals from "./reportWebVitals";
import { Provider } from "react-redux";
import { getBusinessAuthInfo } from "./utils/localstorage";
import { loginSuccess, loginFailed } from "./redux/auth";
import store from "./redux/store";

let businessAuthInfo = getBusinessAuthInfo();
if (businessAuthInfo && Object.keys(businessAuthInfo).length) {
  store.dispatch(loginSuccess(businessAuthInfo));
} else {
  store.dispatch(loginFailed());
}

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <App />
    </Provider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
